export enum TOOL_TYPE {
  TELEPHONE = 'telephone',
  SCREEN = 'screen',
  RECORD = 'record',
  SETTING = 'setting',
  FULLSCREEN = 'fullscreen',
  END = 'end',
}
